module.exports = __webpack_public_path__ + "images/sprites/ui/headline_icon_db_8e710a08588cee77ede563ad3c6cd2ee.png";